import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import FormSwitchery from 'components/forms/FormSwitchery';

class ShareableResourceSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mayBeShared: props.data.may_be_shared,
    };
  }

  updateMayBeShared = (name, value) => {
    const { type, id, updateSettings } = this.props;
    updateSettings(type, id, { [name]: value });

    this.setState({ [name]: value });
  };

  render() {
    const {
      intl: { messages },
    } = this.props;
    const { mayBeShared } = this.state;

    return (
      <div className="clearfix m-t-20">
        <div class="form-group form-group-default padding-10">
          <FormSwitchery
            name="mayBeShared"
            label={messages.allow_others_to_share}
            checked={mayBeShared}
            value
            onChange={this.updateMayBeShared}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.shareSettings,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateSettings: (type, id, args) => {
      formStatusDispatchHelper('shareSettings', `/api/sharedresources/${type}/${id}.json`, args, 'put', dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ShareableResourceSettings)
);
